import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.css";
import { loginAuthProvider } from "../../LoginAuthProvider";
import { removeItem } from "../IndexedDBUtils";

export class Logout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showHelpPages: false,
      };
      
      removeItem('ResellerOrganisation');
      removeItem('ResellerOrgs');
      removeItem('Resellers');
      removeItem('OrgStatuses');
      removeItem('PriceModels');
      sessionStorage.removeItem('ServerPath');
      sessionStorage.removeItem('ResellerID');
      sessionStorage.removeItem('Username');
      sessionStorage.removeItem('orgId');
      sessionStorage.removeItem('orgName');
      sessionStorage.removeItem('IsAdmin');
      sessionStorage.removeItem('ManageTenantDomain');
      removeItem('Branding');
     

    loginAuthProvider.logout();
  }
  static displayName = Logout.name;

  render() {

    return (
      <div id="ContentPlaceHolder1_UpdatePanel1">
      </div>
    );
  }
}
